<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto align-center"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-keyboard-outline',
          title: 'Learn to Code',
          text: 'Anyone can learn to code. Come join us! No experience required. Python? Ruby? Java?',
        },
        {
          icon: 'mdi-cloud-circle',
          title: 'Cloud Services',
          text: 'Learn about the Cloud. Amazon AWS, Microsoft Azure, Heroku. Take your business to the next level.',
        },
        {
          icon: 'mdi-puzzle-outline',
          title: 'Complex Puzzles',
          text: 'Learn to solve interesting puzzles using computer algorithms. Land a job at Facebook, Amazon, Google or Microsoft!',
        },
        {
          icon: 'mdi-database',
          title: 'Databases',
          text: 'Learn about databases. SQL? NoSQL? (No SQL??? What?)',
        },
        // {
        //   icon: 'mdi-flask-plus',
        //   title: 'and much more',
        //   text: 'There is a lot more, from beginner to expert level sessions.',
        // },
      ],
    }),
  }
</script>
